import { createContext } from "react";

export const ConfigContext = createContext(null);
export const AppContext = createContext(null);